import React, { useState, useEffect } from "react";
import dayjs from "dayjs";

export const LiveDateTime = () => {
  var [date, setDate] = useState(new Date());

  useEffect(() => {
    var timer = setInterval(() => setDate(new Date()), 1000);
    return function cleanup() {
      clearInterval(timer);
    };
  });

  return (
    <div className="live-datetime-card">
      <div className="live-date">{dayjs(date).format("MMM DD, YYYY")}</div>
      <div className="live-time"> {dayjs(date).format("h:mm A")}</div>
    </div>
  );
};

export default LiveDateTime;
